module.exports = __webpack_public_path__ + "img/weather.3acad051.png";